import styled from 'styled-components';
import Section from '../Section';

export const Container = styled(Section)({
  padding: '10px 20px',
});

export const SubText = styled.p({
  marginBottom: '0',
  fontSize: '12px',
  lineHeight: '14px',
});
